export default __webpack_public_path__ + "static/media/surf.7a030c52.mp4";